import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RejectedPropertyTab from "../../components/PropertyView/RejectedPropertyTab";
import RejectedDetailsTab from "../../components/PropertyView/RejectedDetailsTab";
import RejectedRoomsTab from "../../components/PropertyView/RejectedRoomsTab";
import DocumentVerificationReject from "../../components/PropertyView/DocumentVerificationReject";
import FollowUp from "../Property/FollowUp";

const RejectedPropertyView = () => {
  const location = useLocation();
  const [tabs, setTabs] = useState(1);
  const data = location.state
  const value = data?.data?.property_type


  const hide = data?.data?.document_status

  console.log('hide', hide)

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Rejected Property View
        </h2>
      </div>
      <div className='d-flex gap-4 mt-3'>
        <h2 onClick={() => { setTabs(1) }} className={`${tabs == 1 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Property
        </h2>
        <h2 onClick={() => { setTabs(2) }} className={`${tabs == 2 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Details
        </h2>
        {value == 1 && (
          <h2 onClick={() => { setTabs(3) }} className={`${tabs == 3 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
            Rooms
          </h2>
        )}
        {hide != 0 && (
          < h2 onClick={() => { setTabs(4); }} className={`${tabs == 4 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`} >
            Document Verification
          </h2>)}

        <h2 onClick={() => { setTabs(5) }} className={`${tabs == 5 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Follow Ups
        </h2>
      </div>

      {tabs == 1 && (
        <RejectedPropertyTab data={data} />
      )
      }
      {
        tabs == 2 && (
          <RejectedDetailsTab data={data} />
        )
      }
      {tabs == 3 && <RejectedRoomsTab data={data} />}
      {tabs == 4 && <DocumentVerificationReject data={data} />}
      {tabs == 5 && <FollowUp data={data} />}
    </div >
  );
};

export default RejectedPropertyView